import React from 'react';
import PropTypes from 'prop-types';
import "./Box.css"

const Box = (props) => {
  const {title, tema, children, footer, hidden} = props;

  return hidden ? children : (
      <div className={('box-' + tema) + " box"}>
        {title && (
          <div className="box-header">
            <h3 className="box-title">{title}</h3>
          </div> 
        )}
        <div className="box-body">
          {children}
        </div>
        {footer && (
          <div class="box-footer clearfix">
            {footer}
          </div>
        )}
      </div>
  );
};

Box.propTypes = {
  title: PropTypes.string,
  tema: PropTypes.string
};

export default Box;



// WEBPACK FOOTER //
// ./src/component/Box/Box.js